<template>
  <BCard class="relative overflow-hidden mb-0 border border-solid min-h-[160px]">
    <div
      class="absolute -bottom-[50px] -right-[90px] z-0"
    >
      <img
        :src="platformBackground"
        alt="background"
        width="220"
        height="220"
        className="object-contain"
      >
    </div>
    <div class="relative z-5 flex flex-col gap-2">
      <span class="text-gray-600 font-medium">Biaya Berlangganan</span>

      <!-- Toggle Switch (requires confirmation via modal before changing state) -->
      <div class="mb-[16px]">
        <b-form-checkbox
          v-model="active"
          switch
          size="lg"
          @change="onToggleChange"
        >
          <span>
            {{ platformName }}
          </span>
        </b-form-checkbox>
      </div>

      <!-- Action Button -->
      <BButton
        v-if="isActive"
        variant="primary"
        size="sm"
        class="w-full rounded"
        @click="handleSetDuration"
      >
        <span class="k-edit" />
        Ubah Biaya Langganan
      </BButton>
    </div>
  </BCard>
</template>

<script>
export default {
  name: 'PlatformCard',
  props: {
    platform: {
      type: String,
      required: true,
      validator: value => ['meta', 'google', 'tiktok'].includes(value),
    },
    partnerId: {
      type: [Number, String],
      default: '',
    },
    requestId: {
      type: [Number, String],
      default: '',
    },
    /**
     * Whether this platform billing is active.
     * This should be controlled by parent component.
     */
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /**
       * Local mirror of active state used for checkbox v-model.
       * We intentionally do NOT change this permanently on user click;
       * instead we revert and ask parent to open confirmation modal.
       */
      active: false,
    }
  },
  computed: {
    platformConfig() {
      const configs = {
        meta: {
          name: 'Meta',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
          background: 'https://storage.googleapis.com/komerce/komads-meta/bg-meta.svg',
        },
        google: {
          name: 'Google',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/google.svg',
          background: 'https://storage.googleapis.com/komerce/komads-meta/bg-google.svg',
        },
        tiktok: {
          name: 'TikTok',
          icon: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
          background: 'https://storage.googleapis.com/komerce/komads-meta/bg-tiktok.svg',
        },
      }
      return configs[this.platform] || configs.meta
    },
    platformName() {
      return this.platformConfig.name
    },
    platformIcon() {
      return this.platformConfig.icon
    },
    platformBackground() {
      return this.platformConfig.background
    },
  },
  watch: {
    /**
     * Keep local checkbox state in sync with parent-provided active state.
     */
    isActive: {
      immediate: true,
      handler(val) {
        this.active = !!val
      },
    },
  },
  methods: {
    /**
     * Handle toggle change.
     * When user clicks the switch, we do NOT commit the state change.
     * Instead, we revert the checkbox and emit an event for the parent to open the setup billing modal.
     * Parent will update `isActive` prop only after successful modal submission.
     * @param {boolean} newValue - Intended next state from the checkbox interaction
     * @returns {void}
     */
    onToggleChange(newValue) {
      const intendedActive = newValue
      // Revert UI immediately; actual change happens after modal submission
      this.active = !newValue
      // Notify parent to open modal with context
      this.$emit('active-billing', {
        platform_name: this.platform,
        intendedActive,
      })
    },
    /**
     * Emit an event to open the Setup Billing modal.
     * @returns {void}
     */
    handleSetDuration() {
      this.$emit('setup-billing', { platform_name: this.platform })
    },
  },
}
</script>

<style scoped>
::v-deep .custom-control-label {
  padding: 0 !important;
  margin: 0 !important;
  font-size: 14px;
  font-weight: 500;
}
</style>
